<template>
  <user-detail :is-edit="false" />
</template>

<script>
import UserDetail from "./userpage";

export default {
  name: "useradd",
  components: { UserDetail }
};
</script>

